import { GoogleOAuthProvider } from "@react-oauth/google";
import "./app.css";

// 設計系統
import { ThemeProvider } from "@/design-system/theme/ThemeContext";

// 應用層
import { AuthProvider } from "@/application/contexts/AuthContext";
import { UserContextProvider } from "@/application/contexts/UserContextProvider";
import { LanguageProvider } from "@/application/contexts/LanguageContext";

// UI 層
import { ErrorBoundary } from "@/ui/components/common/ErrorBoundary";

// 基礎設施層
import "@/infrastructure/i18n";
import { AppRouter } from "@/infrastructure/router";

/**
 * 環境變數常數
 */
const ENV = {
  GOOGLE_CLIENT_ID: import.meta.env.VITE_GOOGLE_CLIENT_ID || "",
};

/**
 * 應用程式主組件
 */
export function App() {
  return (
    <ErrorBoundary>
      <GoogleOAuthProvider clientId={ENV.GOOGLE_CLIENT_ID}>
        <ThemeProvider>
          <LanguageProvider>
            <AuthProvider>
              <UserContextProvider>
                <AppRouter />
              </UserContextProvider>
            </AuthProvider>
          </LanguageProvider>
        </ThemeProvider>
      </GoogleOAuthProvider>
    </ErrorBoundary>
  );
}
